import { ROTransaction, RWTransaction } from '../../../db'
import { Context } from '../../../common'
import { ProductCategory } from '../../productCategories'

export const MAX_COUPONS_COUNT_PER_MONTH = 84
export const CONSUMPTION_RATES_ID = '8d1e908b169b498ba1a6b1fb85244d24'

export interface DBStoredConsumptionRate {
  productCategory: ProductCategory
  averageRate: number
  couponsCountPerMonth: number
}

export interface ConsumptionRatesRepository {
  findAll(tx: ROTransaction): Promise<DBStoredConsumptionRate[]>
  findByProductCategory(
    tx: ROTransaction,
    productCategory: ProductCategory,
  ): Promise<DBStoredConsumptionRate | undefined>
  save(tx: RWTransaction, dbStoredConsumptionRate: DBStoredConsumptionRate): Promise<void>
}

export interface ConsumptionRate {
  averageRate: number
  couponsCountPerMonth: number
}

export type ConsumptionRates = Record<ProductCategory, ConsumptionRate>

export const MAX_COUPONS_BY_CATEGORY: Record<ProductCategory, number> = {
  [ProductCategory.BREAD]: 30,
  [ProductCategory.MEAT]: 4,
  [ProductCategory.FATS]: 2,
  [ProductCategory.VEGETABLES]: 10,
  [ProductCategory.SALT]: 2,
  [ProductCategory.GROATS]: 2,
  [ProductCategory.FISH]: 2,
  [ProductCategory.MILK]: 18,
  [ProductCategory.SUGAR]: 2,
  [ProductCategory.EGGS]: 2,
  [ProductCategory.TOILET_SOAP]: 1,
  [ProductCategory.LAUNDRY_SOAP]: 1,
  [ProductCategory.DETERGENTS]: 1,
  [ProductCategory.MATCHES]: 1,
  [ProductCategory.KEROSENE]: 1,
}

export const DEFAULT_AVERAGE_RATE_BY_CATEGORY: Record<ProductCategory, number> = {
  [ProductCategory.BREAD]: 1,
  [ProductCategory.MEAT]: 1,
  [ProductCategory.FATS]: 1,
  [ProductCategory.VEGETABLES]: 1,
  [ProductCategory.SALT]: 1,
  [ProductCategory.GROATS]: 1,
  [ProductCategory.FISH]: 1,
  [ProductCategory.MILK]: 1,
  [ProductCategory.SUGAR]: 1,
  [ProductCategory.EGGS]: 1,
  [ProductCategory.TOILET_SOAP]: 1,
  [ProductCategory.LAUNDRY_SOAP]: 1,
  [ProductCategory.DETERGENTS]: 1,
  [ProductCategory.MATCHES]: 1,
  [ProductCategory.KEROSENE]: 1,
}

export interface ConsumptionRatesService {
  get(ctx: Context): Promise<ConsumptionRates>
  updateByProductCategory(ctx: Context, productCategory: ProductCategory, opts: Partial<ConsumptionRate>): Promise<void>
}
